/* tslint:disable */
var TTeaserOptions =
{
    buildOptions (mode, selections) {
        var moneyFormat = BetSlip.getMoneyFormat();
        if (Array.getLength(selections) != 0) 
        {
            return `
                <div class="betSlip-row-wrapper" data-uat="bet-slip-row-wrapper">
                    <div class="betSlip-row-content">
                        <div class="betSlip-text-title">
                            ${$dict.bs("TeaserDropdownTitle")}
                        </div>
                        <div class="betSlip-row-stake">
                            ${this.buildTeaserSelectionDropdown()}
                        </div>
                        <div class="betSlip-title-count">
                            <strong data-uat="teaser-odds-text">${$dict.bs("TeaserOddsText")}</strong>
                            <span class="teaser-odds-count" data-uat="teaser-odds-count">${Odds.format(Odds.convertFromAmerican(BetSlip.CurrentMode.getOdds()))}</span>
                        </div>
                        <div class="betSlip-row-stake">
                            <div class="stake-options">
                                <div class="betSlip-stake">
                                    ${this.buildToReturnValue(this.getReturnBoxContent(BetSlip, moneyFormat))}
                                    ${TSlipShared.createStakeBox(this.getTeaserStakeBoxInner(), moneyFormat.format(BetSlip.CurrentMode.Deposit))}
                                </div>
                                ${this.buildTeaserMaxBet(mode)}
                                ${this.createTeaserFreeBetSelect(mode, selections)}
                            </div>
                        </div>
                    </div>
                </div>
            `;
        }
        return "";
    },

    getReturnBoxContent(betSlip, moneyFormat) 
    {
        var value = '';
        if(betSlip && betSlip.CurrentMode && betSlip.CurrentMode.getTotalGain) 
        {
            value = moneyFormat.format(betSlip.CurrentMode.getTotalGain());
        }
        
        return {
            toReturnValue: value,
            id: "teaser_return_value"
        };
    },

    buildTeaserSelectionDropdown ()
    {
        var config = {
            id: "teaser-points",
            cssClasses: "teaser-points",
            inlineHandler: "TeaserSPSlipMode.OptionChanged(this);",
            uat: "bet-slip-teaser-points",
            setData (data)
            {
                var types = BetSlip.CurrentMode.getTeaserTypesForCurrentSelections();
                for (var i in types)
                {
                    var type = types[i];
                    data.push({
                        label: "{0} {1}{2}".format(type.Name, DefaultNumberFormat.format(type.PointsToReduce), "pt Teaser"),
                        value: type.ID,
                        selected: type.ID == BetSlip.CurrentMode.TeaserTypeID
                    });
                }
                return data;
            }
        };

        return TFilterTemplate.custom.build(customSelect.config(config));
    },

    buildToReturnValue(context)
    {
        if (BetSlipUtil.showNAForRelatedSelections()) {
            return '';
        }

        return `
            <div class="betSlip-stake-return returnBox">
                <span class="betSlip-stake-return-head" data-uat="teaser-bet-total-return-label">${$string("BettingHistory").Return}</span>
                <span class="betSlip-stake-return-value" id="${context.id}" data-uat="bet-slip-total-return-value">${context.toReturnValue}</span>
            </div>
        `;
    },

    getTeaserStakeBoxInner()
    {
        return function (__html)
        {
            var changeHandler = "UniSlipBlock.setTeaserStake(this)";
            var keyUpHandler = "UniSlipBlock.setTeaserStake(this)";
            var attributes = TSlipShared.createStakeInputAttributes(changeHandler, keyUpHandler);
            __html.push(`<input class="stakebox" data-uat="stakebox" id="stakebox_teaser" value="${DefaultNumberFormat.format(BetSlip.CurrentMode.Deposit)}" ${attributes} />`);
        };
    },

    buildTeaserMaxBet (mode)
    {
        if (mode.IsMaxBetButtonEnabled()) {
            var title = BetSlip.CurrentMode.getTeaserWaitingAllowed() ? $dict.bs("TeaserOrByRequest") : "";
            return `
                <div class="betslip-maxbet-button" data-uat="bet-slip-max-bet-button">
                    <a href="javascript:TeaserSPSlipMode.SetTeaserMaxBet()" title="${title}">
                        ${$dict.bs("MaxBet")}
                    </a>
                </div>
            `;
        }
        return "";
    },

    createTeaserFreeBetSelect (mode, selections)
    {
        var freeBetsData = Modes.getAvailableTeaserFreeBets(mode, selections, "teaser");
        if (!freeBetsData) { return ""; }
        return TSlipShared.createFreeBetDropDown(freeBetsData);
    }
};

window.TTeaserOptions = TTeaserOptions;
